import { Container } from "./components/Container";
import { Navigation } from "./components/Navigation";
import { DataProvider } from "./context/data";

function App() {

  return (
    <div className="App global-container">
      <DataProvider>
        <Navigation></Navigation>
        <Container></Container>
      </DataProvider>
    </div>
  );
}

export default App;
